import { render, staticRenderFns } from "./Omen.vue?vue&type=template&id=a2920510&lang=pug&"
import script from "./Omen.vue?vue&type=script&lang=js&"
export * from "./Omen.vue?vue&type=script&lang=js&"
import style0 from "../assets/themes/hp-omen/scss/main.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports